(function () {
    'use strict';
    app.controller('usercontroller', ['$scope', 'LoginService', 'progressBarService', '$location', '$cookies', '$rootScope', '$timeout', function ($scope, loginService, progressBarService, $location, $cookies, $rootScope, $timeout) {

        if ($rootScope.globalConfig.adminUser == undefined || $rootScope.globalConfig.adminUser != $cookies.get("userName")) {
            $location.path("/notfound");
            return false;
        }

        $scope.register = function () {
            // Validate user details
            if ($scope.ValidateUserDetails()) {
                progressBarService.showProgressBar();


                var userRegistrationInfo = {
                    FirstName: angular.element("#txtFirstName").val(),
                    LastName: angular.element("#txtLastName").val(),
                    UserName: angular.element("#txtUserName").val(),
                    Email: angular.element("#txtEmailAddress").val(),
                    Password: angular.element("#txtPassword").val(),
                    ConfirmPassword: angular.element("#txtPassword").val()
                };

                loginService.register(userRegistrationInfo).then(function (response) {
                    if (response != null && response.error != undefined) {
                        //$scope.message = response.error_description;
                        alert("Error while saving user : " + response.error_description);
                    }
                    else {
                        $("#txtFirstName").val('');
                        $("#txtFirstName").siblings("label").removeClass("active");
                        $("#txtLastName").val('');
                        $("#txtLastName").siblings("label").removeClass("active");
                        $("#txtUserName").val('');
                        $("#txtUserName").siblings("label").removeClass("active");
                        $("#txtEmailAddress").val('');
                        $("#txtEmailAddress").siblings("label").removeClass("active");
                        $("#txtPassword").val('');
                        $("#txtPassword").siblings("label").removeClass("active");
                        $("#txtConfirmPassword").val('');
                        $("#txtConfirmPassword").siblings("label").removeClass("active");
                        alert("User added successfully");
                    }
                    progressBarService.hideProgressBar();
                });
            }
        };

        $scope.ValidateUserDetails = function () {
            var returnVal = true;
            if (angular.element("#txtFirstName").val() != '') {
                $("#txtFirstName").removeClass("border-red");
                $("#txtFirstName").siblings("label").find("span").fadeOut();
            }
            else {
                $("#txtFirstName").addClass("border-red");
                if (returnVal) {
                    $("#txtFirstName").focus();
                }
                $("#txtFirstName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#txtLastName").val() != '') {
                $("#txtLastName").removeClass("border-red");
                $("#txtLastName").siblings("label").find("span").fadeOut();
            }
            else {
                $("#txtLastName").addClass("border-red");
                if (returnVal) {
                    $("#txtLastName").focus();
                }
                $("#txtLastName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#txtUserName").val() != '') {
                $("#txtUserName").removeClass("border-red");
                $("#txtUserName").siblings("label").find("span").fadeOut();
            }
            else {
                $("#txtUserName").addClass("border-red");
                if (returnVal) {
                    $("#txtUserName").focus();
                }
                $("#txtUserName").siblings("label").find("span").fadeIn();
                returnVal = false;
            }
            if (angular.element("#txtEmailAddress").val() != '') {
                var email = angular.element("#txtEmailAddress").val();
                var regExp = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,3}|[0-9]{1,3})(\]?)$/;

                var isValid = regExp.test(email);
                if (isValid) {
                    $("#txtEmailAddress").removeClass("border-red");
                    $("#txtEmailAddress").siblings("label").find("span").fadeOut();
                }
                else {
                    $("#txtEmailAddress").addClass("border-red");
                    if (returnVal) {
                        $("#txtEmailAddress").focus();
                    }
                    $("#txtEmailAddress").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }
            }
            else {
                $("#txtEmailAddress").addClass("border-red");
                if (returnVal) {
                    $("#txtEmailAddress").focus();
                }
                $("#txtEmailAddress").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            if (angular.element("#txtPassword").val() != '') {
                $("#txtPassword").removeClass("border-red");
                $("#txtPassword").siblings("label").find("span").fadeOut();

                if (angular.element("#txtPassword").val() != angular.element("#txtConfirmPassword").val()) {
                    $("#txtConfirmPassword").addClass("border-red");
                    if (returnVal) {
                        $("#txtConfirmPassword").focus();
                    }
                    $("#txtConfirmPassword").siblings("label").find("span").fadeIn();
                    returnVal = false;
                }
                else {
                    $("#txtConfirmPassword").removeClass("border-red");
                    $("#txtConfirmPassword").siblings("label").find("span").fadeOut();
                }
            }
            else {
                $("#txtPassword").addClass("border-red");
                if (returnVal) {
                    $("#txtPassword").focus();
                }
                $("#txtPassword").siblings("label").find("span").fadeIn();
                returnVal = false;
            }

            return returnVal;
        }

        $scope.setTextboxStyle = function () {
            $(".input-feild-textbox").on("focusin", function () {
                $(this).parent().siblings("label").addClass("active");
                $(this).siblings("label").addClass("active");
            }).focusout(function () {
                if (!$(this).val().trim()) {
                    $(this).parent().siblings("label").removeClass("active");
                    $(this).siblings("label").removeClass("active");
                }
            });
        };

        $scope.setTextboxStyle();

        $(".swipe-wrap").on('focusout', "#txtFirstName", function (e) {
            var getVal = $(this).val();
            if (getVal == '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
        });
        $(".swipe-wrap").on('keyup', "#txtFirstName", function (e) {
            var getVal = $(this).val();
            if (getVal != '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            } else {
                $(this).addClass("border-red");
                $(this).siblings("label").find("span").show();
            }
        });

        $(".swipe-wrap").on('focusout', "#txtLastName", function (e) {
            var getVal = $(this).val();
            if (getVal == '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
        });
        $(".swipe-wrap").on('keyup', "#txtLastName", function (e) {
            var getVal = $(this).val();
            if (getVal != '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
            else {
                $(this).addClass("border-red");
                $(this).siblings("label").find("span").show();
            }
        });

        $(".swipe-wrap").on('focusout', "#txtUserName", function (e) {
            var getVal = $(this).val();
            if (getVal == '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
        });
        $(".swipe-wrap").on('keyup', "#txtUserName", function (e) {
            var getVal = $(this).val();
            if (getVal != '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
            else {
                $(this).addClass("border-red");
                $(this).siblings("label").find("span").show();
            }
        });

        $(".swipe-wrap").on('focusout', "#txtPassword", function (e) {
            var getVal = $(this).val();
            if (getVal == '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
        });
        $(".swipe-wrap").on('keyup', "#txtPassword", function (e) {
            var getVal = $(this).val();
            if (getVal != '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
            else {
                $(this).addClass("border-red");
                $(this).siblings("label").find("span").show();
            }
        });
        $(".swipe-wrap").on('focusout', "#txtEmailAddress", function (e) {
            var getVal = $(this).val();
            if (getVal == '') {
                $(this).removeClass("border-red");
                $(this).siblings("label").find("span").hide();
            }
        });


    }]);
})();